export class Secrets {
    public static FirebaseConfig: any = {
        apiKey: "AIzaSyBi1AVZPJ_imzI_soGOof_YZ0F0TpGz4Tw",
        authDomain: "ajeti-portfolio.firebaseapp.com",
        projectId: "ajeti-portfolio",
        storageBucket: "ajeti-portfolio.firebasestorage.app",
        messagingSenderId: "228473441211",
        appId: "1:228473441211:web:118799883ed9ff3e9b929e",
        measurementId: "G-BK5PXTPD23"
    }
}
